// extracted by mini-css-extract-plugin
export default {"content":"DisableUserModal_content__O1g4r","icon":"DisableUserModal_icon__E8Th6","info":"DisableUserModal_info__PuJmP","buttonRow":"DisableUserModal_buttonRow__ompiB"};